import mergeWith from 'lodash/mergeWith';
import isArray from 'lodash/isArray';

export const mergeData = (contextData, customData) => {
    const customizer = function (objValue, srcValue) {
        if (isArray(objValue) && isArray(srcValue)) {
            return objValue.concat(srcValue);
        }
    }
    return mergeWith(contextData, customData, customizer);
};